// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gCpT","footer":"styles_footer__1rcab","passCodeTooltip":"styles_passCodeTooltip__D8ObX"};